// External pakcages
import { useFormContext, useWatch } from 'react-hook-form';
import * as React from 'react';

// Components
import {
  SelectMultipleField,
  type SelectMultipleFieldProps,
} from 'components/SelectMultiple';
import { PlainButton } from 'components/Button';
import { Option } from 'components/Select';
import { Label } from 'components/Forms';
import { Icon } from 'components/Icons';

// Modules
import { VideoModal } from 'modules/videos/VideoModal';

// Hooks
import { useGetAllMedia } from 'api/media';

// Types
import { Media } from '../../../server/src/types/media.types';

// Utils
import { twMerge } from 'tailwind-merge';

export const VideoSelectField: React.FC<
  Omit<SelectMultipleFieldProps<any>, 'children'> & {
    containerClassName?: string;
  }
> = ({ containerClassName, ...props }) => {
  const { data: media } = useGetAllMedia('videos');
  const { control, setValue } = useFormContext();

  const fieldName = props.name ?? '';
  const selectedIds = useWatch({ control, name: fieldName });
  const selectedVideos =
    media?.filter((item: Media) =>
      Array.isArray(selectedIds) ? selectedIds.includes(item.id) : false
    ) || [];

  return (
    <div className={twMerge(containerClassName)}>
      <SelectMultipleField items={media} {...props} isDisabled={!media?.length}>
        {media.map((item: Media) => (
          <Option key={item.id} id={item.id}>
            <div className="flex items-center gap-2">
              <video className="size-15 md:size-20 object-cover rounded">
                <source src={item.url} type={item.mimeType} />
                Your browser does not support the video tag.
              </video>
              <span>{item.id}</span>
            </div>
          </Option>
        ))}
      </SelectMultipleField>
      {selectedVideos.length > 0 && (
        <div className="px-4 mt-2 md:px-8">
          <Label className="text-sm">Odabrani video</Label>
          <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
            {selectedVideos.map((item: Media) => (
              <div key={item.id} className="relative group/item">
                <video className="object-cover rounded shadow">
                  <source src={item.url} type="video/mp4" />
                  <source src={item.url} type="video/ogg" />
                </video>
                <PlainButton
                  type="button"
                  className="absolute flex border-b border-gray-400 items-center justify-center h-1/2 inset-0 z-10 opacity-0 group-hover/item:opacity-100 cursor-pointer hover:bg-gray-100/80 bg-gray-100/50 text-red-500 transition"
                  onPress={() => {
                    if (Array.isArray(selectedIds)) {
                      setValue(
                        fieldName,
                        selectedIds.filter((id: string) => id !== item.id)
                      );
                    }
                  }}
                  aria-label="Ukloni sliku"
                >
                  <Icon name="x" className="size-8" />
                </PlainButton>
                <VideoModal
                  video={item}
                  key={item.id}
                  modalTrigger={
                    <PlainButton className="absolute flex items-center hover:bg-gray-100/80 justify-center h-1/2 bottom-0 right-0 left-0 z-10 opacity-0 group-hover/item:opacity-100 cursor-pointer bg-gray-100/50 text-blue-500 transition">
                      <Icon name="eye" className="size-8" />
                    </PlainButton>
                  }
                  disableDelete
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
